<template>
<div class="agreement-wrap-card card-certi-border" :style="style">
    <h4 class="sub-title" @click="toggleAllAgreements">
        <div class="chip-checked-circle" :class="allAgreed ? 'selected' : ''">
            <i class="fa-solid fa-check"/>
        </div> 
        전체 동의
        <div class="description">
            <a-tooltip trigger="click" @click="(e) => e.stopPropagation()">
                <div class="question-mark">
                    <i class="fa-solid fa-question" />
                </div>
                <template #title>
                    <div class="description-tooltip">
                        모든 약관에 동의하시면 서비스를 이용할 수 있습니다.
                    </div>
                </template>
            </a-tooltip>
        </div>
    </h4>
    <div class="agree-options-wrap">
        <div v-for="(item, index) in agreements" :key="index">
            <div class="agreement-option">
                <div class="agreement-hover" @click="toggleAgreement(index)">
                    <div class="chip-checked-circle-small" :class="item.isChecked ? 'selected' : ''">
                        <i class="fa-solid fa-check"/>
                    </div>
                    <p>
                        <span>{{ item.title || item.name }}</span>
                    </p>
                    <p class="is-optional">
                        <span>({{ convertAgreementYn(item.requiredYn || item.required) }})</span>
                    </p>
                </div>
                <div class="button-column">
                    <div>
                        <a v-if="item.linkUrl" class="view-policy agreement-hover" :href="item.linkUrl" target="_blank">
                            보기 <i class="fa-solid fa-chevron-right"/>
                        </a>
                        <button v-else @click="openAgreementModal(index)" class="view-policy agreement-hover">
                            보기 <i class="fa-solid fa-chevron-right"/>
                        </button>
                    </div>
                </div>
            </div>
            <p :id="`error-message-${index}`" class="error-message d-none">
                필수 약관에 동의해주세요.
            </p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'AgreementsContainer',
    props: {
        style: String,
        agreements: Array,
        targetLanguage: String,
    },
    emits: ['openAgreementModal', 'toggleAgreement', 'toggleIsAgreedAll', 'agreements-changed'],
    computed: {
        allAgreed() {
            return this.agreements.every(agreement => agreement.isChecked);
        }
    },
    methods: {
        toggleAllAgreements() {
            const newAllAgreedState = !this.allAgreed;
            const updatedAgreements = this.agreements.map(agreement => ({
                ...agreement,
                isChecked: newAllAgreedState
            }));
            this.$emit('agreements-changed', updatedAgreements);
        },
        toggleAgreement(index) {
            const updatedAgreements = [...this.agreements];
            updatedAgreements[index] = {
                ...updatedAgreements[index],
                isChecked: !updatedAgreements[index].isChecked
            };
            this.$emit('agreements-changed', updatedAgreements);
        },
        convertAgreementYn(yn) {
            if(typeof yn === 'string') {
                return yn === 'Y' ? '필수' : '선택';
            } else {
                if(yn === true) return '필수';
                if(yn === false) return '선택';
            }
            return '선택';
        },
        openAgreementModal(index) {
            this.$emit('openAgreementModal', index);
        }
    }
};
</script>
<style lang="scss" scoped>
$Gray-5: #F7F8F8;
$Gray-10: #F1F2F3;
$Gray-20: #E8EBED;
$Gray-30: #DDE0E4;
$Gray-40: #C7CCD1;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$Blue : #278AEC;
$SkyBlue : #E1F0FF;
$Red: #E73023;
.agreement-wrap-card {
    width: 1000px;
    flex: 0 0 auto;
    margin-bottom: 16px;
    max-width: 100%;
    overflow: hidden;
    h4 {
        padding: 14px 20px;
        background-color: white;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        color: $Gray-80;
        line-height: 1.2;
        font-size: 17px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin-bottom: 0 !important;
        transition: 0.3s ease-in-out;
        .chip-checked-circle {
            width: 24px;
            height: 24px;
            border-radius: 100%;
            margin-right: 10px;
            border: 2px solid rgba(0,0,0,0.1);
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: 0.3s ease-in-out;
            i {
                display: none;
                font-size: 13px;
            }
        }
        .chip-checked-circle.selected {
            background-color: $Yellow;
            transition: 0.3s ease-in-out;
            border: none;
            i {
                display: block;
            }
        }
        &:hover {
            background-color: rgb(253, 246, 216);
            transition: 0.3s ease-in-out;
            cursor: pointer;
        }

        .question-mark {
            width: 18px;
            height: 18px;
            border-radius: 18px;
            background-color: $Gray-20;
            display: flex;
            align-items: center;
            border: none;
            justify-content: center;
            i {
                font-size: 11px;
                color: $Gray-90;
            }
        }

        .description {
            display: flex;
            align-items: center;
            margin-left: 8px;
            gap: 4px;
            font-size: 12px;
        }
    }

    .agree-options-wrap {
        background-color: rgba(255,255,255,0.6);
        padding: 12px 0;
        display: flex;
        flex-direction: column;
        .agreement-option {
            padding: 4px 20px 4px 42px;
            display: flex;
            transition: 0.3s ease-in-out;
            justify-content: space-between;
            .agreement-hover {
                padding: 4px 8px;
                display: flex;
                align-items: center;
                border-radius: 8px;
                p {
                    color: $Gray-70;
                    font-weight: 500;
                    line-height: 1.2;
                    font-size: 15px;
                    margin-bottom: 0;
                    display: flex;
                    align-items: start;
                    flex-direction: column;
                }
                .is-optional {
                    margin-left: 10px;
                    font-weight: 400;
                }
                &:hover {
                    background-color: rgba(0,0,0,0.04);
                    transition: 0.3s ease-in-out;
                    cursor: pointer;
                }
            }
        

            .view-policy {
                color: #ACB2B9;
                font-weight: 500;
                line-height: 1.2;
                font-size: 14px;
                margin-left: auto;
                text-decoration: none;
                border: none;
                background-color: transparent;
                i {
                    font-size: 10px;
                    margin-left: 10px;
                    color: #ACB2B9;
                }
            }
            button {
                height: fit-content;
            }
            .chip-checked-circle-small {
                width: 20px;
                height: 20px;
                border-radius: 100%;
                margin-right: 10px;
                border: 2px solid rgba(0,0,0,0.1);
                background-color: white;
                display: flex;
                justify-content: center;
                align-items: center;
                transition: 0.3s ease-in-out;
                flex:none;
                i {
                    display: none;
                    font-size: 13px;
                }
            }
            .chip-checked-circle-small.selected {
                background-color: transparent;
                transition: 0.3s ease-in-out;
                border: none;
                i {
                    display: block;
                }
            }
        }

        .error-message {
            color: #e73023;
            font-size: 13px;
            line-height: 1.2;
            text-indent: 24px;
            font-family: 'SuitRegular', sans-serif;
            margin-left: 50px;
        }
    }
}

@media screen and (max-width:767px) {
    .agreement-wrap-card .agree-options-wrap .agreement-option{
        padding: 2px 10px 2px 21px !important;
    }

    .agreement-wrap-card .agree-options-wrap .agreement-option .agreement-hover {
        flex-wrap: wrap;
    }

    .agree-options-wrap {

        .agreement-option {
            display: flex;
            flex-direction: column;
        }
    }
}

</style>
